import $ from 'jquery';

export default class Home {
  constructor() {
    window.setTimeout(function () {
      $(".home__logo").fadeOut(1500);
    }, 1000);
  }
}
